module.exports = "pegasus/assets/email1-image-3.png";